import { render } from "./notes.vue?vue&type=template&id=86ad20bc&ts=true"
import script from "./notes.vue?vue&type=script&lang=ts"
export * from "./notes.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__